import { usePatch } from "@albertine/api-client";
import { invalidateMemberAndListAllMembers } from "../../common/hooks/useMember";
import type { Agent } from "../../common/types/Agent";
import Button from "../Common/Buttons";
import Icon from "../Common/Icon";
import Label from "../Common/Label";

type AssignMemberToAgentProp = {
    agentToAssign: Agent;
    memberId: string;
};

function AssignMemberToAgent({
    agentToAssign: currentAgent,
    memberId,
}: AssignMemberToAgentProp) {
    const { mutate: sendManageMemberRequest, isPending: loading } = usePatch(
        "manageMember",
        invalidateMemberAndListAllMembers,
    );

    async function assignMemberToMe() {
        sendManageMemberRequest({
            param: { memberId },
            json: {
                assignedAgentId: currentAgent.id,
            },
        });
    }

    return (
        <Button
            onClick={(e) => {
                e.preventDefault();
                assignMemberToMe();
            }}
            showLoadingSpinner={loading}
            nowrap
        >
            <Icon.AssignmentAdd.Small />
            <Label.Medium.Light>Assign to me</Label.Medium.Light>
        </Button>
    );
}

export default AssignMemberToAgent;
